/// <reference path="../../../../typings/tsd.d.ts" /> 
module warsApp.controllers {
    interface IMapConfigurationOverridesScope {
        model:models.MapConfigurationOverridesModel;
    }
    export class MapConfigurationOverridesController {
        constructor($scope: IMapConfigurationOverridesScope,
            mapConfigurationOverridesService: services.MapConfigurationOverridesService,
            mapConfigurationService: services.MapConfigurationService,
            $routeParams: angular.route.IRouteParamsService,
            formService:services.FormService,deleteService:services.DeleteService) {

            var processConfigId = $routeParams["id"];
            $scope.model = new models .MapConfigurationOverridesModel(mapConfigurationOverridesService,
                    mapConfigurationService,formService,deleteService, processConfigId);
        }
    }
}

warsApp.registerController('MapConfigurationOverridesController',
    ['$scope', 'mapConfigurationOverridesService', 'mapConfigurationService', '$routeParams','formService','deleteService']);